import { Component } from '../../../Models/Component';

export enum ComponentsActionType {
  REQUEST_COMPONENTS = 'REQUEST_COMPONENTS',
  RECEIVE_COMPONENTS = 'RECEIVE_COMPONENTS',
}

export type ComponentsAction = IRequestComponentsAction | IReceiveComponentsAction;

export interface IRequestComponentsAction {
  type: ComponentsActionType.REQUEST_COMPONENTS;
}

export interface IReceiveComponentsAction {
  type: ComponentsActionType.RECEIVE_COMPONENTS;
  components: Component[];
}
